import React, { ReactNode } from 'react';

import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Typography } from '@mui/material';
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '100vh' }}>
                    <Box sx={{ border: 'solid 1.5px', borderColor: 'error.main', display: 'inline-block', padding: '0.55rem 0.8rem', borderRadius: '50%' }}>
                        <WarningAmberRoundedIcon sx={{ color: 'errorDialog.dark' }} fontSize={'medium'}/>
                    </Box>
                    <Typography color={'errorDialog.dark'} sx={{ fontWeight: '600', marginTop: '5rem',  position: 'absolute' }}>Something went wrong</Typography>
                </Box>
            );
        }
        return this.props.children;
    }
}

export { ErrorBoundary };
